webpackJsonp([260617349216052],{

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Experience;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _ExperienceCard = __webpack_require__(1158);
	
	var _ExperienceCard2 = _interopRequireDefault(_ExperienceCard);
	
	var _experienceModule = __webpack_require__(1437);
	
	var _experienceModule2 = _interopRequireDefault(_experienceModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Experience(_ref) {
	  var headingText = _ref.headingText,
	      config = _ref.config;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _experienceModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _experienceModule2.default.wrap },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 800 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'black' },
	            headingText
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, alignItems: 'stretch', size: 'l' },
	        config.map(function (item) {
	          return _react2.default.createElement(
	            _grid.GridItem,
	            { columnSpan: 3, columnSpanL: 1 },
	            _react2.default.createElement(_ExperienceCard2.default, {
	              title: item.title,
	              subtitle: item.subtitle,
	              image: item.image
	            })
	          );
	        })
	      )
	    )
	  );
	}
	
	Experience.propTypes = {
	  headingText: _propTypes2.default.string.isRequired,
	  config: _propTypes2.default.array.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ExperienceCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExperienceCard(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 's', type: 'margin', position: 'topBottom' },
	      _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image))
	    ),
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 's', type: 'margin', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 340 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'semibold', size: 'xxl', color: 'black' },
	            title
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 380 },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'black' },
	          subtitle
	        )
	      )
	    )
	  );
	}
	
	ExperienceCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired,
	  subtitle: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Header;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hubspot = __webpack_require__(46);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _headerModule = __webpack_require__(730);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(_ref) {
	  var heading = _ref.heading,
	      subHeading = _ref.subHeading,
	      headerImage = _ref.headerImage,
	      mainColor = _ref.mainColor;
	
	  var requestDemoUrl = '/enterprise/request-demo?hformid=' + _hubspot.requestDemoInvisionSwitchId;
	
	  var buttons = _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'l', position: 'top', type: 'margin' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.buttons },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.leftButton },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: requestDemoUrl },
	          _react2.default.createElement(
	            _button2.default,
	            {
	              size: 'large',
	              background: mainColor,
	              hover: mainColor,
	              shape: 'rounded',
	              minWidth: 180
	            },
	            'Request a demo'
	          )
	        )
	      )
	    )
	  );
	
	  return _react2.default.createElement(
	    _pageWrap2.default,
	    { size: 'l' },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.flex },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.firstCol },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'xxxxl', weight: 'bold', color: 'black' },
	            heading
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 's', position: 'top', type: 'margin' },
	            _react2.default.createElement(
	              _heading2.default,
	              { tag: 'h2', size: 'xxl' },
	              subHeading
	            )
	          ),
	          buttons
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.secondCol },
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.coloredBackground },
	          mainColor === 'blue' && _react2.default.createElement('div', { className: _headerModule2.default.blueChild }),
	          mainColor === 'green' && _react2.default.createElement('div', { className: _headerModule2.default.greenChild })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _headerModule2.default.image },
	          _react2.default.createElement(
	            'div',
	            { className: _headerModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({}, headerImage, { hasShadow: false, block: true }))
	          )
	        )
	      )
	    )
	  );
	}
	
	Header.propTypes = {
	  heading: _propTypes2.default.string.isRequired,
	  subHeading: _propTypes2.default.string.isRequired,
	  headerImage: _propTypes2.default.object.isRequired,
	  mainColor: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Logos;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logoRow = __webpack_require__(53);
	
	var _logoRow2 = _interopRequireDefault(_logoRow);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _logos = __webpack_require__(473);
	
	var _logos2 = _interopRequireDefault(_logos);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _logosModule = __webpack_require__(731);
	
	var _logosModule2 = _interopRequireDefault(_logosModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logos() {
	  return _react2.default.createElement(
	    'div',
	    { className: _logosModule2.default.flex },
	    _react2.default.createElement(_logoRow2.default, {
	      logos: _logos2.default,
	      align: 'center',
	      color: 'black',
	      opacity: 100,
	      spacing: 'm'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: _logosModule2.default.cta },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/customer-stories' },
	          _react2.default.createElement(
	            _ArrowLink2.default,
	            { size: 'm', weight: 'semibold', colour: 'black' },
	            'Read case studies'
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = RequestDemo;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _requestDemoModule = __webpack_require__(732);
	
	var _requestDemoModule2 = _interopRequireDefault(_requestDemoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function RequestDemo(_ref) {
	  var _ref$backgroundColor = _ref.backgroundColor,
	      backgroundColor = _ref$backgroundColor === undefined ? 'blue' : _ref$backgroundColor,
	      image = _ref.image;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _requestDemoModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _requestDemoModule2.default.wrap },
	      backgroundColor === 'green' && _react2.default.createElement(
	        'div',
	        { className: _requestDemoModule2.default.greenContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.left },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'white' },
	            'Switch to Marvel today'
	          ),
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 388 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xl', color: 'white' },
	              'Speak to the team about a personalised demo of Marvel Enterprise for your team.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/enterprise/request-demo' },
	              _react2.default.createElement(
	                _button2.default,
	                {
	                  size: 'extraLarge',
	                  color: 'slate',
	                  hover: 'white',
	                  background: 'white',
	                  shape: 'rounded'
	                },
	                'Request a demo'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.right },
	          _react2.default.createElement(
	            'div',
	            { className: _requestDemoModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image, { block: true }))
	          )
	        )
	      ),
	      backgroundColor === 'blue' && _react2.default.createElement(
	        'div',
	        { className: _requestDemoModule2.default.blueContainer },
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.left },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'white' },
	            'Switch to Marvel today'
	          ),
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 388 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xl', color: 'white' },
	              'Speak to the team about a personalised demo of Marvel Enterprise for your team.'
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', type: 'margin', position: 'top' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/enterprise/request-demo' },
	              _react2.default.createElement(
	                _button2.default,
	                {
	                  size: 'extraLarge',
	                  color: 'slate',
	                  hover: 'white',
	                  background: 'white',
	                  shape: 'rounded'
	                },
	                'Request a demo'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _requestDemoModule2.default.right },
	          _react2.default.createElement(
	            'div',
	            { className: _requestDemoModule2.default.imageChild },
	            _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image, { block: true }))
	          )
	        )
	      )
	    )
	  );
	}
	
	RequestDemo.propTypes = {
	  backgroundColor: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Security;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _ArrowLink = __webpack_require__(75);
	
	var _ArrowLink2 = _interopRequireDefault(_ArrowLink);
	
	var _SecurityCard = __webpack_require__(1160);
	
	var _SecurityCard2 = _interopRequireDefault(_SecurityCard);
	
	var _securityModule = __webpack_require__(1439);
	
	var _securityModule2 = _interopRequireDefault(_securityModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Security() {
	  return _react2.default.createElement(
	    'div',
	    { className: _securityModule2.default.main },
	    _react2.default.createElement(
	      'div',
	      { className: _securityModule2.default.wrap },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 620 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'bold', size: 'xxxxl', color: 'black' },
	            'Trusted by the Fortune 100'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 550 },
	          _react2.default.createElement(
	            _paragraph2.default,
	            { size: 'l' },
	            'Marvel Enterprise provides the level of security and compliance required by 85% of the Fortune 100. We are EU hosted, GDPR compliant and provide enhanced protection such as Single Sign-On and access locks to secure projects.'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'm', type: 'margin', position: 'top' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/security' },
	            _react2.default.createElement(
	              _ArrowLink2.default,
	              { size: 'l', weight: 'semibold', colour: 'blue' },
	              'Read more about Security'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, alignItems: 'flex-end', size: 'l' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'Activity log exports',
	            subtitle: 'Keep an offline record of Marvel activity so you can refer back to it any time you need to',
	            color: 'yellow--l',
	            image: _assets2.default.logoLog,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'GDPR compliant',
	            subtitle: 'We\'re committed to meeting our legal obligation and protecting the data rights of our customers',
	            color: 'purple',
	            image: _assets2.default.logoEU
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'SAML-based SSO',
	            subtitle: 'Marvel Enterprise gives your business several layers of security to their accounts',
	            color: 'orange--l',
	            image: _assets2.default.logoSaml,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'IP Restriction & granular access',
	            subtitle: 'Restrict access by ensuring only users on a specific IP address can access your Marvel account',
	            color: 'marvel',
	            image: _assets2.default.logoGlobe
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: '99.98% Uptime SLA',
	            subtitle: 'Our distributed infrastructure means you get the best and most reliable experience possible',
	            color: 'purple--l',
	            image: _assets2.default.logoArrow,
	            raised: true
	          })
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 3, columnSpanL: 1 },
	          _react2.default.createElement(_SecurityCard2.default, {
	            title: 'EU Hosted Infrastructure',
	            subtitle: 'Our data center maintains multiple certifications including SOC1, SOC 2, SOC 3, ISO27001',
	            color: 'teal',
	            image: _assets2.default.logoMap
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = SecurityCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _securityCardModule = __webpack_require__(1438);
	
	var _securityCardModule2 = _interopRequireDefault(_securityCardModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _securityCardModule2.default));
	
	var bgValues = ['teal', 'marvel', 'purple--l', 'orange--l', 'yellow--l', 'purple'];
	
	function SecurityCard(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      color = _ref.color,
	      raised = _ref.raised,
	      image = _ref.image;
	
	  var blockClasses = cx('flex', { raised: raised });
	  var circleClasses = cx('bg-' + color, 'circle');
	  return _react2.default.createElement(
	    'div',
	    { className: blockClasses },
	    _react2.default.createElement(
	      'div',
	      { className: circleClasses },
	      _react2.default.createElement(_Image2.default, _extends({ hasShadow: false }, image))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _securityCardModule2.default.content },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'left' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'xxs', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h3', weight: 'bold', size: 'm', color: 'black' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'silver' },
	          subtitle
	        )
	      )
	    )
	  );
	}
	
	SecurityCard.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  raised: _propTypes2.default.bool,
	  color: _propTypes2.default.oneOf(bgValues).isRequired,
	  subtitle: _propTypes2.default.string.isRequired,
	  image: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _assets = __webpack_require__(62);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var invisionExperienceConfig = [{
	  title: 'Pricing that scales as you do. No surprises.',
	  subtitle: 'Our customers love our predictable pricing and the confidence it gives them when planning how to scale design across their business. We build plans in partnership with you, complementing your unique organisational stucture and procurement needs.',
	  image: _assets2.default.design
	}, {
	  title: 'Around the clock support from your dedicated team',
	  subtitle: 'Every customer gets the personal support they need from our dedicated experience managers. That means you can pick up the phone or send an email to someone at Marvel that knows your needs inside and out.',
	  image: _assets2.default.support
	}, {
	  title: 'Our customers become our product partners',
	  subtitle: 'We work closely with our customers to build features and integrations that provide the most value in the workflow. Every decision we make ensures our core functionality is exactly what you need, rather than overwhelm your team with things you don’t.',
	  image: _assets2.default.scalable
	}];
	
	exports.default = invisionExperienceConfig;
	module.exports = exports['default'];

/***/ }),

/***/ 1437:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-CompetitorAlternatives-style----experience-module---main---128Qk textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-CompetitorAlternatives-style----experience-module---wrap---2yTHw pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----header-module---flex---3aO63 alignItems-stretch justifyContent-center marginBottom-xl breakPointM-display-flex breakPointM-textAlign-left","firstCol":"src-components-modules-CompetitorAlternatives-style----header-module---firstCol---2I4sT breakPointM-marginBottom-0 breakPointM-marginRight-l breakPointM-textAlign-left textAlign-center marginBottom-l justifyContent-center marginRight-0","buttons":"src-components-modules-CompetitorAlternatives-style----header-module---buttons---2xHYU breakPointM-flexDirection-row flexDirection-column justifyContent-start display-flex","leftButton":"src-components-modules-CompetitorAlternatives-style----header-module---leftButton---1cbOA breakPointM-paddingRight-xxs breakPointM-paddingBottom-0 paddingBottom-xs","rightButton":"src-components-modules-CompetitorAlternatives-style----header-module---rightButton---1KK23 breakPointM-paddingLeft-xxs","secondCol":"src-components-modules-CompetitorAlternatives-style----header-module---secondCol---393rz","coloredBackground":"src-components-modules-CompetitorAlternatives-style----header-module---coloredBackground---3KR-I","blueChild":"src-components-modules-CompetitorAlternatives-style----header-module---blueChild---3Dx4e","coloredBackgroundAnimation":"src-components-modules-CompetitorAlternatives-style----header-module---coloredBackgroundAnimation---3A6pH","greenChild":"src-components-modules-CompetitorAlternatives-style----header-module---greenChild---nXzyk","image":"src-components-modules-CompetitorAlternatives-style----header-module---image---1SOmV","imageChild":"src-components-modules-CompetitorAlternatives-style----header-module---imageChild---1oEe- bg-white","imageAnimation":"src-components-modules-CompetitorAlternatives-style----header-module---imageAnimation---cq3tb","hackyButton":"src-components-modules-CompetitorAlternatives-style----header-module---hackyButton---3zAhF"};

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----logos-module---flex---2YL4I alignItems-center justifyContent-center breakPointL-display-flex breakPointL-textAlign-left","cta":"src-components-modules-CompetitorAlternatives-style----logos-module---cta---2k_-o paddingTop-l breakPointL-paddingLeft-m breakPointL-paddingTop-0"};

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---main---1LaOo textAlign-center paddingTopBottom-xl","blueContainer":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---blueContainer---pH7mg position-relative centered breakPointM-display-flex breakPointM-textAlign-left textAlign-center bg-marvel","greenContainer":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---greenContainer---23FZ7 position-relative centered breakPointM-display-flex breakPointM-textAlign-left textAlign-center","left":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---left---3OL_B breakPointM-padding-xl paddingBottom-l paddingTop-xl","right":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---right---2hOtX paddingBottom-xl paddingLeftRight-l breakPointM-paddingBottom-0 breakPointM-paddingLeft-0 breakPointM-paddingRight-xl","imageChild":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---imageChild---Xn3xO","imageAnimation":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---imageAnimation---2vdIi","wrap":"src-components-modules-CompetitorAlternatives-style----requestDemo-module---wrap---2LBN6 pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 1438:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-components-modules-CompetitorAlternatives-style----security-card-module---flex---mKABp display-flex borderRadius-l","raised":"src-components-modules-CompetitorAlternatives-style----security-card-module---raised---8RyNV bg-snow","circle":"src-components-modules-CompetitorAlternatives-style----security-card-module---circle---1NsqJ marginRight-m display-block overflow-hidden borderRadius-circle","content":"src-components-modules-CompetitorAlternatives-style----security-card-module---content---3DZfT flex-1"};

/***/ }),

/***/ 1439:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"main":"src-components-modules-CompetitorAlternatives-style----security-module---main---1ME5O textAlign-center paddingTopBottom-xl","wrap":"src-components-modules-CompetitorAlternatives-style----security-module---wrap---osT8R pageWrap c-black textAlign-center pageWrap-l"};

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _workflow = __webpack_require__(2664);
	
	var _workflow2 = _interopRequireDefault(_workflow);
	
	var _usertesting = __webpack_require__(2663);
	
	var _usertesting2 = _interopRequireDefault(_usertesting);
	
	var _invisionAlternative = __webpack_require__(2662);
	
	var _invisionAlternative2 = _interopRequireDefault(_invisionAlternative);
	
	var _Prototypes2x = __webpack_require__(2661);
	
	var _Prototypes2x2 = _interopRequireDefault(_Prototypes2x);
	
	var _dashboard2x = __webpack_require__(1090);
	
	var _dashboard2x2 = _interopRequireDefault(_dashboard2x);
	
	var _imageEditor2x = __webpack_require__(1091);
	
	var _imageEditor2x2 = _interopRequireDefault(_imageEditor2x);
	
	var _organise2x = __webpack_require__(1092);
	
	var _organise2x2 = _interopRequireDefault(_organise2x);
	
	var _posterLogos = __webpack_require__(1093);
	
	var _posterLogos2 = _interopRequireDefault(_posterLogos);
	
	var _ogPreview = __webpack_require__(511);
	
	var _ogPreview2 = _interopRequireDefault(_ogPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assetsInv = {
	  workflow: {
	    alt: 'workflow',
	    src: _workflow2.default,
	    maxWidth: 640
	  },
	  usertesting: {
	    alt: 'user testing',
	    src: _usertesting2.default,
	    maxWidth: 640
	  },
	  invisionAlternative: {
	    alt: 'invison alternative',
	    src: _invisionAlternative2.default,
	    maxWidth: 640
	  },
	  prototypes: {
	    src: _Prototypes2x2.default,
	    maxWidth: 640
	  },
	  dashboard: {
	    alt: 'Previews of the Marvel Dashboard',
	    src: _dashboard2x2.default,
	    maxWidth: 725
	  },
	  imageEditor: {
	    alt: 'Image Editor inside Marvel',
	    src: _imageEditor2x2.default,
	    maxWidth: 530
	  },
	  organise: {
	    alt: 'Organise your designs, prototypes and user tests in your folders',
	    src: _organise2x2.default,
	    maxWidth: 660
	  },
	  posterLogos: {
	    src: _posterLogos2.default,
	    maxWidth: 642
	  },
	  sharePreview: {
	    src: _ogPreview2.default,
	    maxWidth: 1200
	  }
	};
	
	exports.default = assetsInv;
	module.exports = exports['default'];

/***/ }),

/***/ 2661:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Prototypes2x-1eaed4d098bfe84307e9cfd3236d1daf.jpg";

/***/ }),

/***/ 2662:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/invisionAlternative-8a2d7c52974dd20561ea9972cecb1a46.png";

/***/ }),

/***/ 2663:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/usertesting-06ca334c1db536a246bd501ca9beb5c2.png";

/***/ }),

/***/ 2664:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/workflow-19a4916c96eb0f1eac7d26dff78694cd.png";

/***/ }),

/***/ 1284:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = MarvelVsInvision;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(1240);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _ImageBlock = __webpack_require__(149);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _Experience = __webpack_require__(1157);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _Header = __webpack_require__(562);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Logos = __webpack_require__(563);
	
	var _Logos2 = _interopRequireDefault(_Logos);
	
	var _Security = __webpack_require__(1159);
	
	var _Security2 = _interopRequireDefault(_Security);
	
	var _RequestDemo = __webpack_require__(564);
	
	var _RequestDemo2 = _interopRequireDefault(_RequestDemo);
	
	var _invisionExperienceConfig = __webpack_require__(1161);
	
	var _invisionExperienceConfig2 = _interopRequireDefault(_invisionExperienceConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookMeta = [{
	  name: 'og:title',
	  content: 'Searching for an InVision alternative?'
	}, {
	  name: 'og:site_name',
	  content: 'Marvel vs InVision'
	}, {
	  name: 'og:type',
	  content: 'website'
	}, {
	  name: 'og:url',
	  content: 'https://marvelapp.com/marvel-vs-invision'
	}, {
	  name: 'og:description',
	  content: 'Join thousands of teams that have switched to Marvel from\n      InVision. We\'re a simple, yet powerful design platform used by\n      over 2 million people to get important work done, faster.'
	}, {
	  name: 'og:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}, {
	  name: 'og:site_name',
	  content: 'Marvel vs InVision'
	}];
	
	var twitterMeta = [{
	  name: 'twitter:site',
	  content: 'https://marvelapp.com/marvel-vs-invision'
	}, {
	  name: 'twitter:creator',
	  content: 'Marvel vs InVision'
	}, {
	  name: 'twitter:title',
	  content: 'Searching for an InVision alternative?'
	}, {
	  name: 'twitter:image',
	  content: 'https://marvelapp.com' + _assets2.default.sharePreview.src
	}];
	
	var meta = {
	  title: _metadata2.default['marvel-vs-invision'].title,
	  meta: [{
	    name: 'description',
	    content: _metadata2.default['marvel-vs-invision'].description
	  }].concat(twitterMeta, facebookMeta),
	  header: { isLight: false },
	  footer: true
	};
	
	function MarvelVsInvision() {
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(_Header2.default, {
	      heading: 'Looking for an InVision alternative?',
	      subHeading: 'We\u2019re a simple, yet powerful design platform used by over 2 million people to get important work done, faster.',
	      headerImage: _assets2.default.dashboard,
	      mainColor: 'blue'
	    }),
	    _react2.default.createElement(_Logos2.default, null),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Your Prototyping, User Testing and Dev Handoff workflow',
	      copy: 'We\u2019re focused on providing the most important, time-saving tools in your workflow in one place. Get everything you need to go from an idea to shipping awesome products in one place. ',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.prototypes
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Create realistic prototypes without code',
	      copy: _react2.default.createElement(
	        'span',
	        null,
	        'Transform designs into prototypes with interactions such as',
	        ' ',
	        _react2.default.createElement(
	          _link2.default,
	          {
	            type: 'blue',
	            url: 'https://help.marvelapp.com/hc/en-us/articles/360014699118-How-to-use-containers-carousels-and-scrolling-sidebars'
	          },
	          'containers'
	        ),
	        ',',
	        ' ',
	        _react2.default.createElement(
	          _link2.default,
	          {
	            type: 'blue',
	            url: 'https://help.marvelapp.com/hc/en-us/articles/360003855577-How-to-embed-YouTube-Vimeo-or-Wistia-videos'
	          },
	          'videos embeds'
	        ),
	        ', timers and more. Easily duplicate the same hotspot across multiple screens for quick work that\u2019s simple for anyone to use.'
	      ),
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.imageEditor,
	      isRightAligned: true
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Validate and ship products faster with User Testing',
	      copy: 'Create user tests that capture video and voice feedback so you can see reactions and listen to your users as they interact with your prototype. Access analytics that provide actionable insights into where your users had issues; eliminating guesswork so you can surface designs that work better.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.usertesting
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Organise your designs, prototypes and user tests into folders',
	      copy: 'Struggling with endless lists of projects in your dashboard and keeping track of all the links you keep sending to your developers and stakeholders? Folders keep everything together in one place and can be shared in public or private in a few clicks.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 435,
	      imageAsset: _assets2.default.organise,
	      isRightAligned: true
	    }),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Switching is easy with simplified change management',
	      copy: 'We offer bespoke project migration support to ensure minimal stress and effort on your part as you move from InVision to Marvel. We can also offer a greater variety of flexible pricing options when you choose to switch, speak to one our product specialists today to find out more.',
	      headingMaxWidth: 435,
	      paragraphMaxWidth: 430,
	      imageAsset: _assets2.default.invisionAlternative
	    }),
	    _react2.default.createElement(_Security2.default, null),
	    _react2.default.createElement(_ImageBlock2.default, {
	      paragraphSize: 'm',
	      title: 'Unlimited customisation with the Marvel API',
	      copy: 'Marvel is the only prototype platform to offer an API, allowing you to customise your workflow. Our GraphQL API gives you the power to build high value, custom workflows, integrations and tools on top of the Marvel platform. We also have dozens of time-saving integrations included such as Sketch, JIRA and many more.',
	      headingMaxWidth: 459,
	      paragraphMaxWidth: 459,
	      imageAsset: _assets2.default.posterLogos
	    }),
	    _react2.default.createElement(_Experience2.default, {
	      headingText: 'A customer experience you can count on',
	      config: _invisionExperienceConfig2.default
	    }),
	    _react2.default.createElement(_RequestDemo2.default, { image: _assets2.default.dashboard })
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-marvel-vs-invision-index-js-3e9cfece7af8f1a32586.js